import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  BehaviorSubject,
  catchError,
  from,
  Observable,
  switchMap,
  throwError,
} from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { clearLocalStorageExceptLastLoginService } from '../services/clearLocalStorageExceptLastLogin.service';

let isRefreshing = false;
const refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
  null
);

export const SecretInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const oauthService = inject(OAuthService);
  const authToken = oauthService.getAccessToken();
  const noti = inject(NzMessageService);
  const router = inject(Router);
  const clearLocalStorageExceptLastLogin = inject(
    clearLocalStorageExceptLastLoginService
  );

  // Kiểm tra nếu URL nằm trong danh sách ngoại lệ thì không thêm token
  if (req.url.includes('https://provinces.open-api.vn/api')) {
    return next(req); // Bỏ qua thêm token
  } else {
    // Nếu có token, thêm nó vào header của request
    if (authToken) {
      req = req.clone({ setHeaders: { Authorization: `Bearer ${authToken}` } });
    }

    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return handle401Error(
            req,
            next,
            oauthService,
            noti,
            router,
            clearLocalStorageExceptLastLogin
          );
        } else {
          return throwError(() => error);
        }
      })
    );
  }
};
// Hàm xử lý khi nhận được lỗi 401 (Unauthorized)
function handle401Error(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  oauthService: OAuthService,
  noti: NzMessageService,
  router: Router,
  clearLocalStorageExceptLastLogin: clearLocalStorageExceptLastLoginService
): Observable<HttpEvent<unknown>> {
  if (!isRefreshing) {
    isRefreshing = true;
    refreshTokenSubject.next(null);

    return from(oauthService.refreshToken()).pipe(
      switchMap((token: any) => {
        localStorage.setItem('access_token', token.access_token);
        localStorage.setItem('refresh_token', token.refresh_token);
        isRefreshing = false;
        refreshTokenSubject.next(token.access_token);
        // refreshTokenSubject.complete();
        // Clone request với token mới
        refreshTokenSubject.complete();
        return next(
          request.clone({
            setHeaders: { Authorization: `Bearer ${token.access_token}` },
          })
        );
      }),
      catchError((err) => {
        isRefreshing = false;
        if (err.status === 401) {
          noti.warning('Hết phiên đăng nhập.Vui lòng đăng nhập lại');
          // localStorage.clear();
          clearLocalStorageExceptLastLogin.clearLocalStorageExceptLastLogin();

          router.navigate(['/login']);
        }
        return throwError(() => err);
      })
    );
  } else {
    return refreshTokenSubject.pipe(
      filter((token) => token != null),
      take(1),
      switchMap((jwt) => {
        return next(
          request.clone({ setHeaders: { Authorization: `Bearer ${jwt}` } })
        );
      })
    );
  }
}
